import SearchBar, { SearchBarOptions } from '@/components/UiElements/SearchBar'

type RoleSearchProps = {
  onSearch: (value: string) => void
  setIsCreateRoleModalOpen: Function
}

const RoleSearch = ({
  onSearch,
  setIsCreateRoleModalOpen
}: RoleSearchProps) => {
  const options: SearchBarOptions[] = [
    {
      label: 'Add Role',
      icon: '',
      iconClassName: 'font-icon-solid',
      onClick: () => setIsCreateRoleModalOpen(true),
      className: '!px-md',
    },
  ];

  return (
    <SearchBar
      placeholder="Search by role name, description..."
      onChange={onSearch}
      options={options}
    />
  )
}

export default RoleSearch
